import React, { useState, useEffect, useRef } from "react";
import Breadcrumb from "../../parts/Breadcrumb";
import { Link } from "react-router-dom";
import ListSection from "../../components/ListSection";
import DeleteModel from "../../components/DeleteModel";
import labels from "../../constants/Label";
import configuration from "../../config";
import { toast } from "react-toastify";
import { pluck } from "underscore";
import Loader from "../../components/Loader/Loader";

// List all labels
function View(location) {
  const [isLoader, setIsLoader] = useState(false);
  const columns = [
    {
      title: "ID",
      field: "id",
      render: (rowData) => (
        <Link
          className="text-indigo-600 hover:text-indigo-900"
          to={`/label/edit/${rowData.label_id}`}
        >
          {rowData.label_id}
        </Link>
      ),
    },
    { title: "Title", field: "title" },
    { title: "Code", field: "label_code" },
  ];
  const btnGroups = [
    { id: 1, title: "Add New", type: "addNew", path: "/label/add" },
    // { id: 2, title: "Export CSV", type: "exportCSV", path: "/label" },
    // { id: 3, title: "Import CSV", type: "importCSV", path: "/label" },
    { id: 5, title: "Delete", type: "delete", path: "/label" },
  ];

  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState([]);
  const [ids, setIds] = useState([]);
  let inputFile = useRef(null);

  useEffect(() => {
    getDatas();
  }, [location.state]);

  function getDatas() {
    setIsLoader(true);
    configuration
      .getAPI({ url: "language-label/list", params: {} })
      .then((data) => {
        if (data.status === 200) {
          setData(data.payload);
        }
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }

  function handleAction(type) {
    if (type === "importCSV") {
      console.log("Open File upload");
      inputFile.click();
    } else {
      if (ids.length < 1) {
        return toast.error("Please select at least one record");
      } else if (type === "delete") {
        setShowModal(true);
        return;
      }
      const sendData = {
        ids,
        type:
          type === "makeActive"
            ? "active"
            : type === "makeInactive"
            ? "inactive"
            : type,
      };
      setIsLoader(true);
      configuration
        .postAPI({ url: "language-label/action", params: sendData })
        .then((data) => {
          if (data.status === 200) {
            getDatas();
            setIds([]);
            setIsLoader(false);
            return toast.success(
              type === "delete"
                ? "Record deleted successfully"
                : "Record updated successfully"
            );
          } else if (data.error) {
            setIsLoader(false);
            return toast.error(data.error.message);
          } else {
            setIsLoader(false);
            return toast.error("Something went wrong");
          }
        })
        .catch((error) => {
          setIsLoader(false);
          return toast.error(error.message);
        });
    }
  }
  function handleDelete() {
    setIsLoader(true);
    const sendData = {
      ids,
      type: "delete",
    };
    configuration
      .postAPI({ url: "language-label/action", params: sendData })
      .then((data) => {
        if (data.status === 200) {
          getDatas();
          setIds([]);
          setShowModal(false);
          setIsLoader(false);
          return toast.success("Record deleted successfully");
        } else if (data.error) {
          setIsLoader(false);
          return toast.error(data.error.message);
        } else {
          setIsLoader(false);
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }
  function handleCancel() {
    setShowModal(false);
  }
  function handleImportCsv(e) {
    setIsLoader(true);
    const formData = new FormData();
    formData.append("csv", e.target.files[0]);
    formData.append("fields", JSON.stringify({ lang_code: "EN" }));
    configuration
      .postFormDataAPI({ url: "language-label/import-csv", params: formData })
      .then((data) => {
        inputFile.value = "";
        // console.log(data)
        if (data.status === 200) {
          getDatas();
          setIds([]);
          setIsLoader(false);
          return toast.success("Successfully import");
        } else if (data.error) {
          setIsLoader(false);
          return toast.error(data.error.message);
        } else {
          setIsLoader(false);
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }

  const onSelectionChange = (e) => {
    let idArr = pluck(e, "label_id");
    setIds(idArr);
  };

  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.label} />
      <DeleteModel
        mode={showModal}
        handleDelete={handleDelete}
        handleCancel={handleCancel}
      />
      <input
        className="profile"
        id="myInput"
        type="file"
        ref={(ref) => (inputFile = ref)}
        onChange={handleImportCsv}
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        style={{ display: "none" }}
      />
      <ListSection
        captionTitle="View Label"
        columns={columns}
        data={data}
        btnGroups={btnGroups}
        csvTitle={"View_Label_"}
        handleAction={handleAction}
        onSelectionChange={onSelectionChange}
      />
    </>
  );
}

export default View;
